
<div class="text-hero" [class.small]="size === 'small'">
  <div class="container">
    <div class="text-hero-container">
      <div>
        <ng-container *ngIf="size !== 'small'" [ngTemplateOutlet]="backButtonTemplate"></ng-container>
        <h2 [class.small]="size === 'small'">
          <mat-icon *ngIf="icon" [svgIcon]="icon" class="icon-title"></mat-icon>
          {{title}}
        </h2>
        <p [class.small]="size === 'small'">
          {{ctaText}}
        </p>
      </div>

      <div *ngIf="icon" class="icon-header">
        <div class="icon-wrapper" [class.small]="size === 'small'">
          <mat-icon [svgIcon]="icon"></mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container" *ngIf="size === 'small'">
  <ng-container [ngTemplateOutlet]="backButtonTemplate"></ng-container>
</div>

<ng-template #backButtonTemplate>
  <a *ngIf="!useBackHistory" [routerLink]="backBtnUrl" [title]="backBtnText"><mat-icon>chevron_left</mat-icon> {{backBtnText}}</a>
  <button *ngIf="useBackHistory" class="link" [class.small]="size === 'small'" (click)="back()"><mat-icon>chevron_left</mat-icon> Back</button>
</ng-template>